import { Stack, Image, ImageFit, Label, IStackTokens, Dialog, DialogType, initializeIcons, TextField, DefaultButton, PrimaryButton, FontIcon, ProgressIndicator, Toggle, Panel, PanelType, IContextualMenuItem, ChoiceGroup, IChoiceGroupOption, IconButton, MessageBar, MessageBarType, Spinner, Checkbox, Link } from '@fluentui/react';
import React, { useContext, useEffect, useState } from 'react';
import styles from '../styles/pokemon.module.scss';
import { GetCards, GetSets, GetBTCPrice, GetSetCardCount, GetFiatPrices, GetCardsCountAll, GetProducts, GetConnect, CardAllUpdates, Init, SetAlert, SearchCards, GetEURPrice, GetUSDPrice } from '../services/DBConnect';
import { ProductType, TInvoice, TProduct, TSale, TSaleProduct, TSet, TShoppingCart, TSize } from '../constants/types';
import Shoppingcart from './shoppingcartComponent';
import { Helmet } from 'react-helmet';
import { CheckIDealPayment, CheckInvoice, CheckInvoiceV3, GetBTCOnchain, GetIDealPayment, GetInvoiceV3 } from '../services/Payment';
import CheckoutComponent from './checkout';
import Globals, { Filters, IsNull } from '../services/Globals';
import SetsMenuComponent from './SetsMenuComponent';
import Boosters from './boostersComponent';
import Collections from './collectionsComponent';
import { ProcessProducts, getFilteredCards } from '../helpers/General';
import Misc from './miscComponent';
import Review from './review';
import { NavLink } from 'react-router-dom';
import CarouselComponent from './carouselComponent';
import PromoComponent from './promoComponent';
import Promo2Component from './promo2Component';
import Footer from './footerComponent';
import PulseLabel from './pulseLabelComponent';
import Search from './searchComponent';
import { FiltersComponent } from './filtersComponent';
import ProductViewerComponent from './Product/productViewerComponent';
import { English, Nederlands } from '../constants/languages/lang';
import NonNLbannerComponent from './nonNLbannerComponent';
import BannerComponent from './bannerComponent';
import EmailAlertComponent from './emailAlertComponent';
import ShowToastComponent from './showToastComponent';
import Producten from './Product/productenComponent';
import WelcomeComponent from './welcomeComponent';
import { ImageViewerSplashContextProvider } from '../_contexts/ImageViewerContext';
import ImageViewerSplash from './ImageViewerSplash/ImageViewerSplash';
import PokemonCardFC from './Product/PokemonCard';
import HeaderFC from './Header';
import GlobalContext from '../_contexts/GlobalContext';
//import SetInfoComponent from './SetInfoComponent';

export interface ImainComponentProps {
    firstComponent: ProductType;
    showSearch?: boolean;
    showText?: string;
}

const MainComponent: React.FunctionComponent<ImainComponentProps> = (props: ImainComponentProps) => {
    const [showFooter, setshowFooter] = useState<boolean>(false);
    const [firstLoad, setfirstLoad] = useState<boolean>(props.firstComponent === ProductType.All ? true : false);
    const [keywords, setkeywords] = useState<string>("Pokemon, kaarten, Bitcoin, BTC, Pokémon, lightning, collectie");
    const [searchAll, setsearchAll] = useState<boolean>(true);
    const [updatedCards, setupdatedCards] = useState([]);
    const [showcards, setshowcards] = useState<boolean>(true);
    const [paymentSuccess, setpaymentSuccess] = useState<boolean>(false);
    const [showCheckOut, setshowCheckOut] = useState<boolean>(false);
    const [showCartPopup, setshowCartPopup] = useState<boolean>(false);
    const [pageCardSet, setpageCardSet] = useState<TProduct[]>([]);
    const [pageIndex, setpageIndex] = useState<number>(0);
    const [numberOfPages, setnumberOfPages] = useState<number>(0);
    const [sets, setsets] = useState([]);
    const [allsets, setallsets] = useState([]);
    const [availablesets, setavailablesets] = useState([]);
    const [filteredCards, setfilteredCards] = useState([]);
    const [cards, setcards] = useState<TProduct[]>([]);
    const [allcards, setallcards] = useState([]);
    const [btcprice, setbtcprice] = useState<number>(99999999);
    const [eurprice, seteurprice] = useState<number>(99999999);
    const [usdprice, setusdprice] = useState<number>(99999999);
    const [satprice, setsatprice] = useState<number>(99999999);
    const [shoppingkart, setshoppingkart] = useState<TShoppingCart>({ items: [] });
    const [init, setinit] = useState<boolean>(true);
    const [invoiceTimoutPercentage, setinvoiceTimoutPercentage] = useState<number>(0);
    const [showSettings, setshowSettings] = useState<boolean>(false);
    const [setsMenu, setsetsMenu] = useState([]);
    const [allMenu, setallMenu] = useState([]);
    const [currentFilter, setcurrentFilter] = useState<Filters>(Filters.CardNumberDown);
    const [waitingIdealPayment, setwaitingIdealPayment] = useState<boolean>(false);
    const [showLocaleBanner, setshowLocaleBanner] = useState<boolean>(false);
    const [boosters, setboosters] = useState([]);
    const [allBoosters, setallBoosters] = useState([]);
    const [collections, setcollections] = useState([]);
    const [allCollections, setallCollections] = useState([]);
    const [producten, setproducten] = useState([]);
    const [misc, setmisc] = useState([]);
    const [allMisc, setallMisc] = useState([]);
    const [showOnly, setshowOnly] = useState<ProductType>(props.firstComponent);
    const [showReviews, setshowReviews] = useState<boolean>(true);
    const [showAddedPanel, setshowAddedPanel] = useState<boolean>(false);
    const [localselectedSetKey, setselectedSetKey] = useState<number>(-1);
    const [selectedCard, setselectedCard] = useState<TProduct>();
    const [localselectedBaseSetKey, setselectedBaseSetKey] = useState<number>(-1);
    const [showBanner, setshowBanner] = useState<boolean>(false);
    const [selectedAlertCard, setselectedAlertCard] = useState<TProduct>();
    const [keepFilterMenuOpen, setkeepFilterMenuOpen] = useState<boolean>(false);
    const [userEmail, setuserEmail] = useState<string>("");
    const [alertCoachmarkVisible, setalertCoachmarkVisible] = useState<boolean>(false);
    const [searchText, setsearchText] = useState<string>();
    const [toastMessage, settoastMessage] = useState<string>();
    const [isToastError, setisToastError] = useState<boolean>(false);
    const [popupUrl, setpopupUrl] = useState<string>();
    const [invoiceCreatedAt, setinvoiceCreatedAt] = useState<Date>();
    const [invoice, setinvoice] = useState<TInvoice>();
    const [toastTimeout, settoastTimeout] = useState<number>();
    const [searchTime, setsearchTime] = useState<number>();
    const [searchTicker, setsearchTicker] = useState<number>();
    const [searchBusy, setsearchBusy] = useState<boolean>(false);
    const [onChainAddress, setonChainAddress] = useState<string>();
    const [prevselectedSetKey, setprevselectedSetKey] = useState<number>();
    const [filterOptions, setfilterOptions] = useState<IChoiceGroupOption[]>();
    const [loading, setloading] = useState<boolean>(false);
    const [triggerLoadCard, settriggerLoadCard] = useState<number>(Date.now());
    
    let popUpSwipeRight: Function;
    let popUpSwipeLeft: Function;

    const cardTokens: IStackTokens = {
        childrenGap: 10,
        padding: 5
    };

    const { DevEnabled, DebugEnabled, BitcoinEnabled, ReviewID, DLog, ImagesUrlVersionAddition, GlobalInit, Strings, selectedSetName, SetPageWidth, windowSize, SetwindowSize,
            SetIsMobile, PROMO1_IMAGE_URL, PROMO2_IMAGE_URL, SITE_MESSAGE, SetStrings, HIDDEN_SETS, showAvailableOnly, setshowAvailableOnly, 
            SITE_MESSAGE_START_DATE, SITE_MESSAGE_END_DATE, IsMobile, SetselectedSetName, AnimationsEnabled, SetAnimationsEnabled, GlobalImagesVersion } = useContext(GlobalContext);

    const pageSize = windowSize.x < 960 ? 20 : 36;

    useEffect(() => {
        if (init) {
            DLog("mainComponent useEffect [init]");
            console.warn = console.error = () => { }; //disable warnings
            initializeIcons();
            SetExchangeRates();

            const cacheURL = DevEnabled ? `../cache/init.json?${Date.now()}` : `${process.env.PUBLIC_URL}/cache/init.json?${Date.now()}`

            DLog(cacheURL);

            //If cache file is available load it
            fetch(cacheURL).then(response => response.json()).then(cachedValues => {
                DLog(cachedValues);
                GlobalInit(cachedValues, Nederlands, ShowMessage, windowSize.x < 960 ? true : false, windowSize.x - 25 > 1232 ? 1232 : windowSize.x); 
                InitStoredValues(cachedValues);
            }).catch( err => {
                console.log(err);
                Init(showAvailableOnly, DevEnabled).then(values => {
                    DLog(values);
                    GlobalInit(values, Nederlands, ShowMessage, windowSize.x < 960 ? true : false, windowSize.x - 25 > 1232 ? 1232 : windowSize.x); 
                    InitStoredValues(values);
                }).catch(err => {
                    console.log(err);
                });
            });
            
            CheckCacheNeedsUpdate();
        }
    }, [init]);

    useEffect(() => {
        if (BitcoinEnabled) {
            DLog("mainComponent useEffect [invoiceTimoutPercentage]");
            const interval = 5000;

            if (invoiceTimoutPercentage < 100) {
                setTimeout(() => {
                    CheckInvoiceComplete();
                }, interval);
            }
        }
    }, [invoiceTimoutPercentage]);

    useEffect(() => {
        DLog("mainComponent useEffect [invoiceCreatedAt]");
        CheckInvoiceComplete();
    }, [invoiceCreatedAt]);

    useEffect(() => {
        DLog("mainComponent useEffect [boosters, collections, misc, allBoosters, allCollections, allMisc]");
        updateProducten();
    }, [boosters, collections, misc, allBoosters, allCollections, allMisc]);

    useEffect(() => {
        DLog("mainComponent useEffect [cards]");
        onPagingChange(0);
    }, [cards]);

    useEffect(() => {
        DLog("mainComponent useEffect [selectedCard]");
        if (selectedCard) {
            SetCards(sets.filter(set => set.id == selectedCard.setID)[0].name, showAvailableOnly, false, () => {
                setshowAddedPanel(false);
                setsearchText(selectedCard.scardnumber);
                onSearchBoxChange(selectedCard.scardnumber);
            });
        }
    }, [selectedCard]);

    useEffect(() => {
        DLog("mainComponent useEffect [searchAll]");
        setkeepFilterMenuOpen(true);
        searchText && onSearchBoxChange(searchText);
    }, [searchAll]);

    useEffect(() => {
        DLog("mainComponent useEffect [selectedSetKey,sets]");
        LoadCards();
    }, [localselectedSetKey,triggerLoadCard]);

    useEffect(() => {
        DLog("mainComponent useEffect [searchTime,searchTicker]");
        if (searchText) {
            if ((Date.now() - searchTime) > 500) {
                setsearchBusy(true);
                if (firstLoad) {
                    setfirstLoad(false);
                }
                doSearch();
            } else {
                setTimeout(() => {
                    setsearchTicker(Date.now());
                }, 100);
            }
        } else {
            doSearch();
        }
    }, [searchTime,searchTicker]);

    useEffect(() => {
        //Check if we got a site message to show
        if (SITE_MESSAGE_START_DATE <= new Date() && SITE_MESSAGE_END_DATE >= new Date()) {
            setshowBanner(true);
        }
    },[SITE_MESSAGE]);

    const LoadCards = () => {
        DLog("LoadCards()");
        if (sets.length && localselectedSetKey && localselectedSetKey > -1) {
            setloading(true);
            const setname = sets.filter(set => set.id == localselectedSetKey)[0].name;
            SetselectedSetName(setname);
            SetCards(setname, showAvailableOnly).then(() => {
                setloading(false);
            }).catch(err => {
                setloading(false);
                console.log(err);
            });
        }
    }

    const CheckCacheNeedsUpdate = async () : Promise<void> => {
        DLog("CheckCacheNeedsUpdate()");
        return new Promise((resolve, reject) => {
            //Check if cache needs an update
            Init(showAvailableOnly, DevEnabled).then(values => {
                DLog(values);
                if (values.updateneeded === true) {
                    DLog("Cache update needed");
                    GlobalInit(values, Nederlands, ShowMessage, windowSize.x < 960 ? true : false, windowSize.x - 25 > 1232 ? 1232 : windowSize.x); 
                    InitStoredValues(values);
                }
            }).catch(err => {
                console.log(err);
            });
        });
    }

    const Refresh = () => {
        DLog("mainComponent Refresh()");
        setfilterOptions([
            { key: Filters.PriceUp, text: Strings.PriceHighToLow },
            { key: Filters.PriceDown, text: Strings.PriceToLowHigh },
            { key: Filters.CardNumberUp, text: Strings.CardNumberHighToLow },
            { key: Filters.CardNumberDown, text: Strings.CardNumberLowToHigh },
        ]);
        if (BitcoinEnabled) {
            setbtcprice(btcprice - 0.001); 
        }
    }

    const ShowAlertCoachmarks = () => {
        DLog("mainComponent ShowAlertCoachmarks()");
        setshowAvailableOnly(true);
        setalertCoachmarkVisible(true);
        toggleAvailable();
    }

    const InitStoredValues = (values) => {
        DLog("mainComponent InitStoredValues()");
        setfilterOptions([
            { key: Filters.PriceUp, text: Strings.PriceHighToLow },
            { key: Filters.PriceDown, text: Strings.PriceToLowHigh },
            { key: Filters.CardNumberUp, text: Strings.CardNumberHighToLow },
            { key: Filters.CardNumberDown, text: Strings.CardNumberLowToHigh },
        ]);
        
        if (BitcoinEnabled) {
            setbtcprice(values.btcprice);
            setsatprice(values.btcPrice / 100000000);
        }

        const pathName = decodeURI(window.location.pathname);
        const subString = pathName.substring(1, pathName.length);
        const parts = subString.split('/');

        if (parts.length === 2 && parts[0] === "Pokemon Kaarten") {
            values.sets.forEach(_set => {
                if (_set.name === parts[1]) {
                    SetselectedSetName(_set.name);
                    setselectedSetKey(_set.id);
                    setselectedBaseSetKey(_set.parentid);
                    ProcessSets(values.sets, true);
                }
            });
        } else {
            ProcessSets(values.sets, true);
            ProcessCards(values.cards, selectedSetName);
        }
        setTimeout(() => {
            GetConnect(IsMobile);
            SetAnimationsEnabled(true);
        }, 2000);

        //Give client some breathing time before loading in booster images
        setTimeout(() => {
            setboosters(ProcessProducts(values.boosters));
            setcollections(ProcessProducts(values.collections));
            setmisc(ProcessProducts(values.misc));
            updateProducten();
            if (!showAvailableOnly) {
                setallBoosters(ProcessProducts(values.boosters));
                setallCollections(ProcessProducts(values.collections));
                setallMisc(ProcessProducts(values.misc));
            }
        }, 1000);
        //Start the price polling
        setTimeout(() => {
            SetExchangeRates();
        }, 10000);
    }

    const updateProducten = () => {
        if (searchBusy === false) {
            DLog("mainComponent updateProducten()");
            let producten: TProduct[] = [];
            misc.forEach(prod => {
                if (prod.setID === localselectedSetKey || prod.showInSets.filter(sn => sn === localselectedSetKey?.toString()).length > 0) {
                    producten.push(prod);
                }
            });
            boosters.forEach(prod => {
                if (prod.setID === localselectedSetKey || prod.showInSets.filter(sn => sn === localselectedSetKey?.toString()).length > 0) {
                    producten.push(prod);
                }
            });
            collections.forEach(prod => {
                if (prod.setID === localselectedSetKey || prod.showInSets.filter(sn => sn === localselectedSetKey?.toString()).length > 0) {
                    producten.push(prod);
                }
            });

            let availableProds = producten.filter(p => p.available > 0);
            let notavailableProds = producten.filter(p => p.available === 0);

            availableProds.sort((a, b) =>
                a.order < b.order ? -1 : 1
            );

            notavailableProds.sort((a, b) =>
                a.order < b.order ? -1 : 1
            );

            setproducten(availableProds.concat(notavailableProds));
        }
    }

    const SetExchangeRates = async () : Promise<any> => {
        DLog("mainComponent SetPrice()");
        if (BitcoinEnabled) {
            return GetBTCPrice(DevEnabled).then(price => {
                if (price != btcprice) {
                    setbtcprice(price);
                    setsatprice(price / 100000000);
                }
            }).catch(err => {
                console.log(err);
                setTimeout(() => {
                    SetExchangeRates();
                }, 10000);
            });    
        } 

        GetFiatPrices(DevEnabled).then(prices => {
            if (prices[0] != usdprice || prices[1] != eurprice) {
                setusdprice(prices[1]);
                seteurprice(prices[0]);
            }
            setTimeout(() => {
                SetExchangeRates();
            }, 30000);
        }).catch(err => {
            setTimeout(() => {
                SetExchangeRates();
            }, 10000);
        });
    }

    const SetCards = async (setname: string, availableOnly: boolean = true, isAllCards: boolean = false, callback: Function = null) : Promise<void> => {

        DLog(`mainComponent SetCards(${setname}, ${availableOnly}, ${isAllCards}, ${callback})`);
        return new Promise((resolve, reject) => {
            if (IsNull(setname)) {
                //setcards([]);
                //setpageCardSet([]);
                setinit(false);
                if (isAllCards === true) {
                    setallcards([]);
                    if (searchText) {
                        onSearchBoxChange(searchText);
                    }
                    if (callback) {
                        callback();
                    }
                    resolve();
                } else {
                    let _cards = filteredCards;
                    if (availableOnly) {
                        setallcards(filteredCards);
                        _cards = filteredCards.filter(c => c.available > 0);
                    } else {
                        setallcards([]);
                    }
                    const _currentPageSet = getCurrentPageSet(0, _cards);
                    setpageCardSet(_currentPageSet);
                    resolve();
                }
            } else {
                if (sets.length) {
                    GetCards(setname, availableOnly, DevEnabled).then(_cards => {
                        if (DebugEnabled) {
                            console.log({_cards});
                        }
                        ProcessCards(_cards, setname, callback, isAllCards);
                        if (searchText) {
                            onSearchBoxChange(searchText);
                        }
                        resolve();
                    }).catch(err => {
                        reject(err);
                    });
                }
            }
        });
    }

    const ProcessCards = (_cards: TProduct[], setname: string, callback: Function = null, isAllCards: boolean = false) => {
        DLog("mainComponent ProcessCards()");
        const setid = sets.filter(set => set.name === setname)[0]?.id;

        _cards.forEach(card => {
            if (card.number > 99) {
                card.scardnumber = `${card.number}`;
            } else if (card.number > 9) {
                card.scardnumber = `0${card.number}`;
            } else {
                card.scardnumber = `00${card.number}`;
            }
            if (card.size > 99) {
                card.scardnumber += `/${card.size}`;
            } else if (card.size > 9) {
                card.scardnumber += `/0${card.size}`;
            } else {
                card.scardnumber += `/00${card.size}`;
            }

            //TODO: move to backend, minimale prijs toevoegen
            card.priceInUSD = Math.round(card.priceInUSD * 100) / 100;
            card.cost = Math.round(card.priceInUSD / satprice);
            card.scost = `${card.cost}`;
            card.setID = setid;
            let imageUrls: string[] = [];
            card.imageNames?.split(',').forEach(imageName => {
                imageUrls.push(`${process.env.PUBLIC_URL}/assets/pokemon/${card.setID}/${card.number.toString()}/${imageName}?v=${GlobalImagesVersion}`);
            });
            imageUrls.push(`${process.env.PUBLIC_URL}/assets/pokemon/cardback.webp?v=${GlobalImagesVersion}`);
            card.imageUrls = imageUrls;
        });

        _cards.sort((a, b) => a.priceInUSD < b.priceInUSD ? 1 : -1);

        const _currentPageSet = getCurrentPageSet(0, _cards);
        if (isAllCards === true) {
            setallcards(_cards);
        }

        setcards(_cards);
        setpageCardSet(_currentPageSet);
        setinit(false);

        filter(currentFilter, _cards);

        if (callback) {
            callback();
        }
    }

    const filter = (filter: string = Filters.CardNumberDown, _cards : TProduct[] = []) => {
        DLog("mainComponent filter()");
        setcurrentFilter(filter as Filters);
        if (_cards.length > 0) {
            if (searchAll) {
                _cards = getFilteredCards(filteredCards?.length ? filteredCards : _cards, filter);
            } else {
                _cards = getFilteredCards(_cards, filter);
            }

            const _currentPageSet = getCurrentPageSet(0, _cards);
            setpageCardSet(_currentPageSet);
            setfilteredCards(_cards);
            setshowSettings(false);
        } else {
            setpageCardSet([]);
            setfilteredCards([]);
            setshowSettings(false);
        }
    }

    const getCurrentPageSet = (newIndex: number, _currentSet: TProduct[]) : TProduct[] => {
        DLog("mainComponent getCurrentPageSet()");
        const _startIndex = newIndex * pageSize;
        let endIndex = _startIndex + pageSize;
        if (endIndex > _currentSet.length) {
            endIndex = _currentSet.length;
        }
        const _currentPageSet = _currentSet.slice(_startIndex, endIndex);
        setpageIndex(newIndex);
        setnumberOfPages(Math.round(_currentSet.length / pageSize));
        return _currentPageSet;
    }

    const SetSets = (showAvailableOnly: boolean = true): Promise<void> => {
        DLog("mainComponent SetSets()");
        return new Promise((resolve, reject) => {
            GetSets(DevEnabled, false).then(sets => {
                ProcessSets(sets, showAvailableOnly);
                resolve();
            });
        });
    }

    const ProcessSets = (sets: TSet[], showAvailableOnly: boolean) => {
        DLog("mainComponent ProcessSets()");
        const oldSets = sets;
        let newSets: TSet[] = oldSets;
        let hiddensetids = HIDDEN_SETS?.length ? HIDDEN_SETS.split(',') : [];
        sets.forEach(oset => {
            oset.releasedate = new Date(oset.releasedate);
            if (hiddensetids.indexOf(oset.id.toString()) === -1) {
                if (newSets.filter(s => s.id === oset.id).length === 0) {
                    newSets.push(oset);
                }
            }
        });
        setsets(newSets);
        GetSetsCardCountAll(newSets);
    }

    const GetSetsCardCountAll = (sets: TSet[]) => {
        DLog("mainComponent GetSetsCardCountAll()");
        GetCardsCountAll(DevEnabled, 1).then(cardCounts => {
            sets.forEach(set => {
                const fsets = cardCounts.filter(c => c.setname === set.name);
                if (fsets.length === 1) {
                    set.cardcount = fsets[0].ammount;
                }
            });
            setSetMenuItems(sets, showAvailableOnly);
        });
    }

    const setSetMenuItems = (sets: TSet[], showAvailableOnly: boolean) => {
        DLog("mainComponent setSetMenuItems()");
        let basesets: TSet[] = [];
        let expsets: TSet[] = [];

        sets.sort((a, b) => a.releasedate <= b.releasedate ? 1 : -1);

        sets.forEach(set => {
            if (!IsNull(set.parentid) && set.parentid !== 0) {
                expsets.push(set);
            }
        });

        sets.forEach(set => {
            if (IsNull(set.parentid) || set.parentid === 0) {
                basesets.push(set);
            }
        });

        const currentBaseSet = sets.filter(set => set.id === localselectedBaseSetKey)[0];
        let currentexpsets = expsets.filter(set => set.parentid === localselectedBaseSetKey);
        currentexpsets.push(currentBaseSet);

        let menuItems: IContextualMenuItem[] = [];
        menuItems.push({
            key: "search", text: "Zoeken in alle sets", onRender(item, dismissMenu) {
                return <NavLink to='/Zoeken' style={{ textDecoration: "none", color: 'black' }}>
                    <Stack style={{ whiteSpace: "nowrap" }} verticalAlign='center' horizontalAlign='start' horizontal className={styles.menuItem}>
                        <IconButton iconProps={{ iconName: 'Search' }}
                            styles={{
                                icon: { paddingLeft: 0, color: 'blue', fontSize: windowSize.x > 960 ? 16 : 14 },
                                root: {
                                    margin: 0,
                                    padding: 0,
                                }
                            }} />
                        <span className={styles.menuItem} >{Strings.SearchInAllSets}</span>
                    </Stack>
                </NavLink>
            }
        });

        basesets.forEach(baseset => {
            let submenuItems: IContextualMenuItem[] = [];
            let subitems = expsets.filter(set => set.parentid === baseset.id);
            subitems.forEach(subitem => {
                let setName = subitem.name;
                if (subitem.cardcount) {
                    setName += ` (${subitem.cardcount})`;
                }
                submenuItems.push({
                    key: subitem.id.toString(),
                    text: setName,
                    onClick: () => { onSetSelectedSet(subitem.id); },
                    onRender(item: IContextualMenuItem, dismissMenu) {
                        return <div className={styles.menuItem} onClick={() => { onSetSelectedSet(subitem.id); dismissMenu(null, true); }}>
                                   {setName}
                               </div>
                                
                    }
                });
            });
            if (submenuItems.length) {
                let setName = baseset.expansion;
                if (baseset.cardcount) {
                    setName += ` (${baseset.cardcount})`;
                }
                submenuItems.push({
                    key: baseset.id.toString(),
                    text: setName,
                    onClick: () => { onSetSelectedSet(baseset.id); },
                    onRender(item: IContextualMenuItem, dismissMenu) {
                        return <div className={styles.menuItem} onClick={() => { onSetSelectedSet(baseset.id); dismissMenu(null, true); }}>
                                {setName}
                               </div>
                                
                    }
                });
                menuItems.push({
                    key: baseset.id.toString() + "_" + baseset.id.toString(),
                    text: baseset.expansion,
                    items: submenuItems,
                    //href: `/Pokemon Kaarten/${baseset.name}`,
                } as IContextualMenuItem);
            } else {
                let setName = baseset.name;
                if (baseset.cardcount) {
                    setName += ` (${baseset.cardcount})`;
                }
                menuItems.push({
                    key: baseset.id.toString(),
                    text: setName,
                    onMouseDown: () => { onSetSelectedSet(baseset.id); }
                } as IContextualMenuItem);
            }
        });

        let allMenuItems: IContextualMenuItem[] = [];
        <NavLink to='/'>
            <PrimaryButton text='Alles' style={{ width: "100%" }} onClick={() => { setshowSettings(false); }} />
        </NavLink>

        allMenuItems.push({
            key: "All", text: "Home", onRender(item, dismissMenu) {
                return <NavLink to='/' style={{ textDecoration: "none" }} className={styles.menuItem}>
                    <div onClick={() => { setshowSettings(false); dismissMenu(null, true); }}>
                        <Stack horizontal>
                            <IconButton iconProps={{ iconName: 'Home' }}
                                styles={{
                                    icon: { paddingLeft: 0, marginLeft: -2, color: 'blue', fontSize: windowSize.x > 960 ? 16 : 14 },
                                    root: {
                                        margin: 0,
                                        padding: 0,
                                    }
                                }} />
                            <span className={styles.menuItem} >Home</span>
                        </Stack>
                    </div>
                </NavLink>
            }
        });
        allMenuItems.push({ key: "Cards", text: Strings.Cards, items: menuItems });

        let productMenuItems: IContextualMenuItem[] = [];
        productMenuItems.push({
            key: "Boosters", text: "Boosters", onRender(item: IContextualMenuItem, dismissMenu) {
                return <NavLink to='/Pokemon Boosters' style={{ textDecoration: "none" }} className={styles.menuItem} onClick={() => { setfirstLoad(false); setshowSettings(false); dismissMenu(null, true); }}>
                    <div className={styles.menuItem} >
                        Boosters
                    </div>
                </NavLink>
            }
        });
        productMenuItems.push({
            key: "Collections", text: Strings.Collections, onRender(item: IContextualMenuItem, dismissMenu) {
                return <NavLink to='/Pokemon Collecties' style={{ textDecoration: "none" }} className={styles.menuItem} onClick={() => { setfirstLoad(false); setshowSettings(false); dismissMenu(null, true); }}>
                    <div className={styles.menuItem} >
                        {Strings.Collections}
                    </div>
                </NavLink>
            }
        });
        productMenuItems.push({
            key: "Misc", text: Strings.Misc, onRender(item: IContextualMenuItem, dismissMenu) {
                return <NavLink to='/Pokemon Diverse' style={{ textDecoration: "none" }} className={styles.menuItem} onClick={() => { setfirstLoad(false); setshowSettings(false); dismissMenu(null, true); }}>
                    <div className={styles.menuItem} >
                        {Strings.Misc}
                    </div>
                </NavLink>
            }
        });
        allMenuItems.push({ key: "Products", text: Strings.Products, items: productMenuItems });
        allMenuItems.push({
            key: "Marktplaats", onRender(item, dismissMenu) {
                return <NavLink to='/Marktplaats' style={{ textDecoration: "none" }} className={styles.menuItem}>
                    <div onClick={() => { setshowSettings(false); dismissMenu(null, true); }}>
                        <Stack horizontal verticalAlign='center'>
                            <Image style={{ width: 16, paddingLeft: 5, paddingRight: 10 }} src={process.env.PUBLIC_URL + `/assets/marktplaatsIcon.webp?v=${GlobalImagesVersion}`} />
                            <span className={styles.menuItem} >{Strings.BuyOnMarktplaats}</span>
                        </Stack>
                    </div>
                </NavLink>
            }
        });

        setsetsMenu(menuItems);
        setallMenu(allMenuItems);
        if (showAvailableOnly === false) {
            if (!allcards.length)
                setallsets(sets);
        } else {
            if (!availablesets.length)
                setavailablesets(sets);
        }
    }

    const onBuyClick = (product: TProduct): boolean => {
        DLog("mainComponent onBuyClick()");
        let _shoppingkart: TShoppingCart = shoppingkart;
        let filtered = _shoppingkart.items.filter(i => i.product.id === product.id);
        if (filtered.length) {
            if (filtered[0].ammount + 1 <= product.available) {
                filtered[0].ammount++;
                setshoppingkart(_shoppingkart);
                setisToastError(false);        
                settoastMessage(`${product.title} ${Strings.AddedToCart}`);
                return true;
            }
        } else {
            shoppingkart.items.push({ ammount: 1, product: product });
            setshoppingkart(_shoppingkart);
            setisToastError(false);        
            settoastMessage(`${product.title} ${Strings.AddedToCart}`);
            return true;
        }
        setisToastError(true);
        settoastMessage(Strings.NotAvailable);
        return false;
    }

    const onImageClick = (url: string) => {
        DLog("mainComponent onImageClick()");
        setpopupUrl(url);
    }

    const onSetSelectedSet = (value?: string | number) => {
        DLog("mainComponent onSetSelectedSet()");
        setshowOnly(ProductType.Cards);
        setupdatedCards([]);
        setfilteredCards([]);
        setpageCardSet([]);
        setsearchText(null);
        setsearchAll(false);
        setshowSettings(false);
        setinit(false);
        setfirstLoad(false);
        setselectedSetKey(value as number);
        settriggerLoadCard(Date.now());
    }

    const onPagingChange = (newIndex: number) => {
        DLog("mainComponent onPagingChange()");
        const currentSet = filteredCards.length ? filteredCards : cards;
        const currentPageSet = getCurrentPageSet(newIndex, currentSet);
        setpageCardSet(currentPageSet);
        setpageIndex(newIndex);
    }

    const onSmallCartClick = () => {
        DLog("mainComponent onSmallCartClick()");
        setshowCartPopup(true);
    }

    const onPreCheckOut = () => {
        DLog("mainComponent onPreCheckOut()");
        setshowCheckOut(true);
        setshowCartPopup(false);
    }

    const onCheckOutIDeal = (sale: TSale) => {
        DLog("mainComponent onCheckOutIDeal()");
        let productids: TSaleProduct[] = [];
        shoppingkart.items.forEach(item => {
            for (let i = 0; i < item.ammount; i++) {
                productids.push({ id: item.product.id, setid: item.product.isProduct ? -1 : item.product.setID, ammount: item.ammount });
            }
        });
        sale.products = productids;
        //console.log(sale);
        GetIDealPayment(DevEnabled, sale).then(value => {
            if (value.success != false) {
                if (window.open === null) {
                    setTimeout(() => {
                        CheckIDealComplete(value.paymentResponse.id);
                    }, 5000);
                    setwaitingIdealPayment(true);
                    document.location = value.paymentResponse.links.checkout.href;
                } else {
                    window.open(value.paymentResponse.links.checkout.href, "_blank").focus();
                    setTimeout(() => {
                        CheckIDealComplete(value.paymentResponse.id);
                    }, 5000);
                    setwaitingIdealPayment(true);
                }
            } else {
                alert(value.errorString);
            }
        }).catch(err => {
            console.log(err);
            alert("Interne server fout: " + err);
        });
    }

    const CheckIDealComplete = (id: string) => {
        DLog("mainComponent CheckIDealComplete()");
        const interval = 2000;
        if (id && !paymentSuccess) {
            CheckIDealPayment(DevEnabled, id).then(result => {
                //console.log({result});
                if (result.success === true) {
                    switch (result.paymentResponse.status) {
                        case "open":
                            setTimeout(() => {
                                CheckIDealComplete(id);
                            }, interval);
                            break;
                        case "paid":
                            setshoppingkart({ items: [] });
                            setpaymentSuccess(true);
                            break;
                        default:
                            alert("Betaling niet gelukt. Status: " + result.paymentResponse.status);
                            break;
                    }
                } else {
                    console.log(result);
                    //alert("Betaling verwerking niet gelukt. "+result.errorString);
                }
            }).catch(err => {
                console.log(err);
                console.log("Unable to check iDeal payment");
            });
        } else {
            console.log("Unable to check iDeal payment");
        }
    }

    const onCheckOut = (sale: TSale) => {
        DLog("mainComponent onCheckOut()");
        let cardids: TSaleProduct[] = [];
        shoppingkart.items.forEach(item => {
            for (let i = 0; i < item.ammount; i++) {
                cardids.push({ id: item.product.id, setid: item.product.isProduct ? -1 : item.product.setID, ammount: item.ammount });
            }
        });
        sale.products = cardids;
        GetInvoiceV3(DevEnabled, sale).then(value => {
            if (value.success != false) {
                setinvoice(value);
                setinvoiceTimoutPercentage(0);
                setinvoiceCreatedAt(new Date());
            } else {
                alert(value.errorString);
            }
        }).catch(err => {
            alert("Interne server fout.");
        });
    }

    const CheckInvoiceComplete = () => {
        if (BitcoinEnabled) {
            DLog("mainComponent CheckInvoiceComplete()");
            if (invoice) {
                if (invoice.id)
                    CheckInvoiceV3(DevEnabled, invoice.id).then((result: Boolean) => {
                        if (result) {
                            setshoppingkart({ items: [] });
                            setpaymentSuccess(true);
                        } else {
                            const totalSeconds = 900; //15 minutes x 60 seconds
                            const interval = 5000;

                            if (invoiceCreatedAt) {
                                const ms = (new Date()).getTime() - invoiceCreatedAt?.getTime();
                                const perc = ((ms + interval) / 1000) / totalSeconds;
                                setinvoiceTimoutPercentage(perc);
                            }
                        }
                    });
            }
        }
    }

    const ShowMessage = (msg: any, timeout: number = 2000, isError: boolean = true) => {
        DLog("mainComponent ShowMessage()");
        setTimeout(() => {
            settoastMessage(msg);
            setisToastError(isError);
            settoastTimeout(timeout);
        }, 100);
    }

    const ClosePayment = () => {
        DLog("mainComponent ClosePayment()");
        setshowCheckOut(false);
        setwaitingIdealPayment(false);
        setinvoice(undefined);
        setpaymentSuccess(false);
        setwaitingIdealPayment(false);
        SetSets(true).then(() => {
            SetCards(selectedSetName).then(() => {
                
            });
        });
    }

    const toggleAvailable = () => {
        DLog("mainComponent toggleAvailable()");
        
        if (showAvailableOnly === true) {
            SetCards(sets.filter(set => set.id === localselectedSetKey)[0]?.name, false, true);
        } else {
            SetCards(sets.filter(set => set.id === localselectedSetKey)[0]?.name, true, false);
        }
        
        if (showAvailableOnly === true) {
            let _boosters: TProduct[] = boosters;
            let _allBoosters: TProduct[] = allBoosters;
            let _collections: TProduct[] = collections;
            let _allCollections: TProduct[] = allCollections;
            let _misc: TProduct[] = misc;
            let _allMisc: TProduct[] = allMisc;

            if (allBoosters.length) {
                _boosters = allBoosters;
            } else {
                GetProducts(ProductType.Booster, showAvailableOnly, DevEnabled).then(prods => {
                    const products = ProcessProducts(prods);
                    _boosters = products;
                    _allBoosters = products;
                }).catch(ex => {
                    console.log(ex);
                });
            }

            if (allCollections.length) {
                _collections = allCollections;
            } else {
                GetProducts(ProductType.Collection, showAvailableOnly, DevEnabled).then(prods => {
                    const products = ProcessProducts(prods);
                    _collections = products;
                    _allCollections = products;
                }).catch(ex => {
                    console.log(ex);
                });
            }

            if (allMisc.length) {
                _misc = allMisc;
            } else {
                GetProducts(ProductType.Misc, showAvailableOnly, DevEnabled).then(prods => {
                    const products = ProcessProducts(prods);
                    _misc = products;
                    _allMisc = products;
                }).catch(ex => {
                    console.log(ex);
                });
            }

            setboosters(_boosters);
            setcollections(_collections);
            setmisc(_misc);
            setallBoosters(_allBoosters);
            setallCollections(_allCollections);
            setallMisc(_allMisc);
        } else {
            setboosters(allBoosters.filter(prod => prod.available > 0));
            setcollections(allCollections.filter(prod => prod.available > 0));
            setmisc(allMisc.filter(prod => prod.available > 0));
        }

        setshowAvailableOnly(!showAvailableOnly);
        setshowSettings(false);
    }

    const copyToClipboard = (text: string) => {
        DLog("mainComponent copyToClipboard()");
        let clipBoardElem = document.createElement("input");
        document.body.appendChild(clipBoardElem);
        clipBoardElem.value = text;
        clipBoardElem.select();
        let successfulCopy = document.execCommand('copy');
        document.body.removeChild(clipBoardElem);
        if (successfulCopy) {
            settoastMessage("Gekopieerd naar klembord");
        } else {
            alert("Kopieren naar klembord mislukt");
        }
    }

    const doSearch = (sstring: string = searchText) => {
        DLog("mainComponent doSearch()");
        if (sstring && sstring.length > 0) {
            searchAll && setselectedSetKey(-1);
            if (searchAll === false) {
                let _cards = getFilteredCards(cards, currentFilter);
                if (_cards?.length) {
                    sstring = sstring?.toLocaleLowerCase();
                    if (sstring && !IsNull(sstring)) {
                        const filteredCards = _cards.filter(card =>
                            card.title?.toLocaleLowerCase().indexOf(sstring) !== -1 ||
                            card.rarety?.toLocaleLowerCase().indexOf(sstring) !== -1 ||
                            card.scardnumber?.indexOf(sstring) !== -1 ||
                            card.version?.toLocaleLowerCase().indexOf(sstring) !== -1
                        );
                        const currentPageSet = getCurrentPageSet(0, filteredCards);

                        setshowSettings(false);
                        setpageCardSet(currentPageSet);
                        setfilteredCards(filteredCards);
                    } else {
                        let currentPageSet = getCurrentPageSet(0, _cards);

                        setshowSettings(false);
                        setpageCardSet(currentPageSet);
                        setfilteredCards(_cards);
                    }
                }
                setsearchBusy(false);
            } else {
                SearchCards(sstring, showAvailableOnly, DevEnabled).then(scards => {
                    let _cards = getFilteredCards(scards, currentFilter);
                    _cards.forEach(card => {
                        if (card.number > 99) {
                            card.scardnumber = `${card.number}`;
                        } else if (card.number > 9) {
                            card.scardnumber = `0${card.number}`;
                        } else {
                            card.scardnumber = `00${card.number}`;
                        }
                        card.scardnumber += `/${card.size}`;

                        //TODO: move to backend, minimale prijs toevoegen
                        card.priceInUSD = Math.round(card.priceInUSD * 100) / 100;
                        card.cost = Math.round(card.priceInUSD / satprice);
                        card.scost = `${card.cost}`;
                        let imageUrls: string[] = [];
                        card.imageNames.split(',').forEach(imageName => {
                            imageUrls.push(`${process.env.PUBLIC_URL}/assets/pokemon/${card.setID}/${card.number.toString()}/${imageName}?v=1`);
                        });
                        imageUrls.push(`${process.env.PUBLIC_URL}/assets/pokemon/cardback.webp?v=1`);
                        card.imageUrls = imageUrls;
                    });

                    _cards.sort((a, b) => a.priceInUSD < b.priceInUSD ? 1 : -1);
                    let currentPageSet = getCurrentPageSet(0, _cards);

                    setshowSettings(false);
                    setpageCardSet(currentPageSet);
                    setfilteredCards(_cards);
                    setsearchBusy(false);
                });
            }
        } else {
            const currentPageSet = getCurrentPageSet(0, cards);

            setshowSettings(false);
            setfilteredCards(cards);
            setpageCardSet(currentPageSet);
            setsearchBusy(false);
        }
    }

    const onSearchBoxChange = (newValue?: string | undefined) => {
        DLog(`mainComponent onSearchBoxChange(${newValue})`);
        const _searchTime = Date.now();
        setsearchText(newValue);
        setsearchTime(_searchTime);
    }

    const loadMore = () => {
        DLog("mainComponent loadMore()");
        const newIndex = pageIndex === 0 ? 2 : pageIndex + 1;
        const currentSet = filteredCards.length ? filteredCards : cards;
        let endIndex = pageSize * newIndex;
        if (endIndex > currentSet.length) {
            endIndex = currentSet.length;
        }

        const _currentPageSet = currentSet.slice(0, endIndex);

        setpageIndex(newIndex);
        setpageCardSet(_currentPageSet);
        setnumberOfPages(currentSet.length / pageSize);
    }

    const onOnChainPayment = () => {
        DLog("mainComponent onOnChainPayment()");
        if (invoice) {
            if (invoice.id) {
                GetBTCOnchain(DevEnabled, invoice.id).then(btcAddress => {
                    if (btcAddress.Success) {
                        setonChainAddress(btcAddress.Address);
                    } else {
                        //TODO: handle error
                        alert(btcAddress.ErrorString);
                    }
                }).catch(err => {
                    alert(err);
                });
            }
        }
    }

    const ShowImagePopup = (imageUrl: string, onSwipeLeft: Function, onSwipeRight: Function) => {
        DLog("mainComponent ShowImagePopup()");
        setpopupUrl(imageUrl);
        popUpSwipeLeft = onSwipeLeft;
        popUpSwipeRight = onSwipeRight;
    }

    const SetSelectedProductForAlert = (prod: TProduct) => {
        DLog("mainComponent SetSelectedProductForAlert()");
        setselectedAlertCard(prod);
    }

    const SetAlertCallback = (email?: string, prod?: TProduct) => {
        DLog("mainComponent SetAlertCallback()");
        if (email && prod) {
            SetAlert(prod.id, prod.setID, prod.name, email).then(result => {
                if (result) {
                    ShowMessage(Strings.AlertAdded, 3000, false);
                }
            }).catch(err => {
                console.log(err);
                ShowMessage(Strings.AlertFailed, 5000);
            });
        }
        setselectedAlertCard(null);
        setuserEmail(email);
    }

    const UpdateStateExtern = (props: string[], vals: any[]): Promise<void> => {
        DLog("mainComponent UpdateStateExtern()");
        return new Promise((resolve, reject) => {
            let stateObj = {};
            for (let i = 0, l = props.length; i < l; i++) {
                const prop = props[i];
                const val = vals[i];

                switch (prop) {
                    case "firstLoad":
                        setfirstLoad(val);
                        resolve();
                        break;
                    case "searchAll":
                        setsearchAll(val);
                        resolve();
                        break;
                    case "selectedSetKey":
                        setselectedSetKey(val);
                        resolve();
                        break;
                    case "showFooter":
                        setshowFooter(val);
                        resolve();
                        break;
                    default:
                        console.log(`${prop} but it is not found`);
                        resolve();
                        break;

                }
            }
        });
    }

    //catch back button in browser
    if (firstLoad === false && 
        IsNull(searchText) && 
        localselectedSetKey === -1 && 
        props.firstComponent === ProductType.All) {
        setfirstLoad(true);
    }

    if (props.firstComponent != showOnly) {
        setshowOnly(props.firstComponent);

        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 200);
    }

    if (prevselectedSetKey != localselectedSetKey) {
        setprevselectedSetKey(localselectedSetKey);
        let keywords = "Pokemon, kaarten, Pokémon, collectie";
        const pathName = decodeURI(window.location.pathname);
        const prodName = pathName.substring(1, pathName.length);
        const parts = prodName.split('/');
        if (parts.length > 2) {
            let [setname, cardname, number, version] = (parts[1] + parts[2]).split(" - ");

            if (setname === undefined) {
                setname = sets.find(set => set.id == localselectedSetKey)?.name;
            }

            keywords = `${setname}, ${keywords}`;

            if (version !== undefined) {
                keywords = `${cardname} - ${version}, ${keywords}`;
            }

            if (cardname !== undefined) {
                keywords = `${cardname}, ${keywords}`;
            }
        } else {
            if (parts.length > 1) {
                let [setname] = (parts[1]).split(" - ");
                keywords = `${setname}, ${keywords}`;
            } else {
                keywords = `${selectedSetName}, ${keywords}`;
            }
        }

        updateProducten();

        setkeywords(keywords);
    }

    const pageTitle = () : string => {
        if (selectedSetName) {
            return selectedSetName;
        }
        if (selectedCard) {
            return selectedCard.title;
        }
        return "Pokémon Collectie";
    }

    return (
        init == true ? <div></div> : props.showSearch ? <Search animationsEnabled={AnimationsEnabled}
            windowSize={windowSize}
            eurprice={eurprice}
            satprice={satprice}
            usdprice={usdprice}
            onBuyClick={onBuyClick}
            isDev={DevEnabled}
            onImageClick={onImageClick}
            onPreCheckOut={onPreCheckOut}
            onSmallCartClick={onSmallCartClick}
            allMenu={allMenu}
            shoppingkart={shoppingkart} /> :
            <ImageViewerSplashContextProvider>
                <div className={styles.mainDiv}>
                    <ImageViewerSplash />
                    <ShowToastComponent message={toastMessage} isError={isToastError} timeout={toastTimeout} callback={() => {
                        settoastMessage(undefined);
                        setisToastError(undefined);
                        settoastTimeout(undefined);
                    }} />
                    <Helmet>
                        <title>{pageTitle()}</title>
                        <meta property="og:image" content="https://pokemoncollectie.nl/assets/metalogo.webp?v=${GlobalImagesVersion}" />
                        <meta name="description" content="De nieuwste Pokémon kaarten, boosters en producten." />
                        <meta name="keywords" content={keywords} />
                        <meta name="author" content="DITC - Mark" />
                    </Helmet>
                    {/* Added Panel settings */}
                    <Panel
                        isOpen={showAddedPanel}
                        customWidth={windowSize.x > 960 ? `${windowSize.x / 2}px` : '350px'}
                        type={PanelType.customNear}
                        isHiddenOnDismiss
                        isLightDismiss
                        onDismiss={(ev) => { if (showAddedPanel === true) { ev.preventDefault(); } else { setshowAddedPanel(false); } }}
                        closeButtonAriaLabel="Sluiten"// You MUST provide this prop! Otherwise screen readers will just say "button" with no label.
                        hasCloseButton={false}
                        onLightDismissClick={() => { setshowAddedPanel(false); }}
                    >
                        {showAddedPanel &&
                            <Stack>
                                <Stack horizontalAlign='center'>
                                    <Stack horizontal style={{ zIndex: 1, position: "absolute", backgroundColor: "white", width: "95%", marginTop: -5 }} tokens={{ padding: 5 }}>
                                        <Stack style={{ width: "100%" }}>
                                            <span style={{ width: "100%", fontSize: "large", fontWeight: "600" }}>{Strings.RecentlyAdded}</span>
                                        </Stack>
                                        <Stack horizontalAlign='end'>
                                            <span style={{ fontSize: "large", fontWeight: "600", marginRight: 20, cursor: "pointer" }} onClick={() => { setshowAddedPanel(false); }}>X</span>
                                        </Stack>
                                    </Stack>
                                    <IconButton /> {/* No clue why but somehow an orange/blue border is added on the first iconbutton in this component */}
                                    {updatedCards.map(card => {
                                        return <Stack style={{ width: "100%" }} horizontal tokens={{ padding: 5 }}>
                                            <Stack horizontalAlign='center' >
                                                <Image className={styles.setLogoMenuSmall} src={process.env.PUBLIC_URL + `/assets/pokemon/${card.setID}/${card.setID}.webp?v=${GlobalImagesVersion}`} />
                                            </Stack>
                                            <Stack verticalAlign='center'>
                                                <span style={{ whiteSpace: "nowrap" }}>{card.lastAddedAmmout.toString()}x&nbsp;</span>
                                            </Stack>
                                            <Stack verticalAlign='center'>
                                                <img className={styles.checkoutCardImg}
                                                    onClick={() => { setpopupUrl(card.imageUrls[0]); popUpSwipeLeft = null; popUpSwipeRight = null; }}
                                                    src={card.imageUrls[0]} alt="" />
                                            </Stack>
                                            <Stack verticalAlign='center' style={{ paddingLeft: 2, width: "100%" }}>
                                                {card.scardnumber} - {card.title}
                                                <PulseLabel style={{ fontSize: "small!important", fontWeight: "bold" }} text={`€ ${parseFloat((card.priceInUSD * eurprice).toString()).toFixed(2)}`} />
                                            </Stack>
                                            <NavLink to='/' style={{ textDecoration: "none" }}>
                                                <Stack verticalAlign='center' horizontalAlign='center' className={styles.removeActive}>
                                                    <IconButton iconProps={{ iconName: 'View' }}
                                                        onClick={() => {
                                                            if (localselectedSetKey === card.setID) {
                                                                setshowAddedPanel(false);
                                                                setsearchText(card.scardnumber);
                                                                onSearchBoxChange(card.scardnumber);
                                                            } else {
                                                                setshowOnly(ProductType.Cards);
                                                                setselectedCard(card);
                                                                setselectedSetKey(card.setID);
                                                                setshowSettings(false);
                                                            }
                                                        }}
                                                        styles={{
                                                            icon: { fontSize: 20 },
                                                            root: {
                                                                border: 0,
                                                                margin: 0,
                                                                padding: 0,
                                                            }
                                                        }} />
                                                    <span style={{ cursor: "pointer", fontSize: "xx-small" }}>{Strings.View}</span>
                                                </Stack>
                                            </NavLink>
                                        </Stack>
                                    })}
                                    {updatedCards.length >= 199 && <Label>{Strings.RecentlyAddedMore1} <NavLink to='/Zoeken'>{Strings.SearchLowerCase}</NavLink> {Strings.RecentlyAddedMore2}</Label>}
                                    {updatedCards.length === 0 && <Label>{Strings.RecentlyAddedNone}</Label>}
                                    <br />
                                    <PrimaryButton text={Strings.Close} onClick={() => { setshowAddedPanel(false); }} style={{ maxWidth: 200 }} />
                                </Stack>
                            </Stack>
                        }
                    </Panel>
                    {/* Settings Panel settings */}
                    <Panel
                        headerText="Menu"
                        isOpen={showSettings}
                        customWidth={windowSize.x > 960 ? '350px' : '280px'}
                        type={PanelType.custom}
                        isHiddenOnDismiss={true}
                        isLightDismiss
                        onDismiss={() => { setshowSettings(false); }}
                        closeButtonAriaLabel="Sluiten"// You MUST provide this prop! Otherwise screen readers will just say "button" with no label.
                    >
                        {showSettings &&
                            <Stack tokens={cardTokens} horizontalAlign='start'>
                                <div className={styles.filterContainers}>
                                    <PrimaryButton style={{ width: "100%" }} menuProps={{ items: allMenu, shouldFocusOnMount: true, subMenuHoverDelay: 250 }} >Menu</PrimaryButton>
                                </div>
                                <div className={styles.filterContainers}>
                                    <Stack>
                                        <Label style={{ fontWeight: "bold", paddingBottom: 5, marginBottom: 5 }}>Site taal / language</Label>
                                        <Stack horizontal>
                                            <div style={{ paddingTop: 5, paddingRight: 10, cursor: "pointer" }} className={styles.nl} onClick={() => { SetStrings(Nederlands); Refresh(); }}></div>
                                            <Label style={{ cursor: "pointer" }} onClick={() => { SetStrings(Strings); Refresh(); }}>Nederlands</Label>
                                        </Stack>
                                        <Stack horizontal>
                                            <div style={{ paddingTop: 5, paddingRight: 10, cursor: "pointer" }} className={styles.eng} onClick={() => { SetStrings(English); Refresh(); }}></div>
                                            <Label style={{ cursor: "pointer" }} onClick={() => { SetStrings(English); Refresh(); }}>English</Label>
                                        </Stack>
                                        <Label style={{ marginTop: 5 }}>* Delivery is only done within the Netherlands. For delivery outsite the Netherlands please contact us for options.</Label>
                                    </Stack>
                                </div>
                                <div className={styles.filterContainers}>
                                    <ChoiceGroup disabled={showOnly != ProductType.All && showOnly != ProductType.Cards} className={styles.filterChoice} defaultSelectedKey="B" selectedKey={currentFilter} options={filterOptions} onChange={(ev, option) => { filter(option ? option.key : Filters.PriceUp); }} label="Filters" required={true} />
                                </div>
                                <div className={styles.filterContainers}>
                                    <Toggle label={Strings.Animations} checked={AnimationsEnabled} inlineLabel onChange={() => { SetAnimationsEnabled(!AnimationsEnabled); }} />
                                </div>
                                <div className={styles.filterContainers}>
                                    <Toggle label={Strings.SoldoutToggle} checked={!showAvailableOnly} inlineLabel onChange={toggleAvailable} />
                                </div>
                                <div className={styles.filterContainers}>
                                    <Toggle label={Strings.SearchInAllSets} checked={searchAll} inlineLabel onChange={() => {
                                        setsearchAll(!searchAll);
                                        setkeepFilterMenuOpen(true);
                                        !searchText && onSearchBoxChange(searchText);
                                    }} />
                                </div>
                                <div className={styles.filterContainers}>
                                    <NavLink to='/Zoeken' style={{ textDecoration: "none", color: 'black' }}>
                                        <Stack style={{ whiteSpace: "nowrap" }} verticalAlign='center' horizontalAlign='start' horizontal>
                                            <IconButton iconProps={{ iconName: 'Search' }}
                                                styles={{
                                                    icon: { color: 'blue', fontSize: windowSize.x > 960 ? 16 : 14 },
                                                    root: {
                                                        height: "auto",
                                                        margin: 2,
                                                        padding: 2,
                                                    }
                                                }} />
                                            <Label style={{ cursor: "pointer" }}>{Strings.SearchInAllSets}</Label>
                                        </Stack>
                                    </NavLink>
                                </div>
                                <Footer />
                            </Stack>
                        }
                    </Panel>
                    {/* Shopping cart */}
                    <Dialog
                        hidden={!showCartPopup}
                        dialogContentProps={{ type: DialogType.normal }}
                        onDismiss={() => { setshowCartPopup(false); }}
                        modalProps={{ styles: { main: { maxHeight: "100%!important", width: 800, height: 800, maxWidth: "100%!important", backgroundColor: "transparent", boxShadow: "none", overflowY: "auto" } } }}
                    >
                        <Stack horizontalAlign='center'>
                            <Shoppingcart pShowMessage={ShowMessage} isPopup={true} eurprice={eurprice} usdprice={usdprice} showPopup={(v: string) => { setpopupUrl(v); }} satprice={satprice} shoppingcart={shoppingkart} onCheckOut={onPreCheckOut} onSmallCartClick={() => { setshowCartPopup(false); }} />
                        </Stack>
                    </Dialog>
                    {/* Invoice popup */}
                    <Dialog
                        hidden={!invoice}
                        dialogContentProps={{ type: DialogType.normal }}
                        onDismiss={() => { ClosePayment(); }}
                        modalProps={paymentSuccess ? { styles: { scrollableContent: { maxHeight: "100%", maxWidth: "100%", width: "100%" }, main: { maxHeight: "100%!important", width: "100%", height: "100%", maxWidth: "95%!important", backgroundColor: "transparent", boxShadow: "none", overflowY: "hidden" } } }
                            : { styles: { scrollableContent: { maxHeight: "100%", maxWidth: "100%" }, main: { maxHeight: "100%!important", width: 800, maxWidth: "95%!important", backgroundColor: "white", boxShadow: "none", overflowY: "hidden" } } }}
                    >
                        <Stack className={styles.invoiceMain} horizontalAlign='center'> {/* TODO: component van maken */}
                            <h2>Betaling {invoice?.sats} sats, € {Math.round(invoice?.sats * satprice * eurprice * 100) / 100}</h2>
                            {onChainAddress ?
                                <div>
                                    <br />
                                    <br />
                                    <Label><u>Uw uniek betaal adres:</u></Label>
                                    <div className={`${styles.aPanel} ${styles.clickable}`} onClick={() => { invoice?.invoice && copyToClipboard(onChainAddress ? onChainAddress : ""); }}>
                                        <Stack horizontal className={`${styles.clickable} ${styles.invoiceStack}`} verticalAlign='center'>
                                            <FontIcon aria-label="Kopieer" iconName="copy" className={styles.copyInvoiceIcon} />
                                            <Label className={`${styles.invoiceLabel} ${styles.onchainLabel}`}>{onChainAddress}</Label>
                                        </Stack>
                                    </div>
                                    <br />
                                    <Label><u>Bitcoin bedrag:</u></Label>
                                    <div className={`${styles.aPanel} ${styles.clickable}`} onClick={() => { invoice?.invoice && copyToClipboard((invoice?.sats / 100000000).toString()); }}>
                                        <Stack horizontal className={`${styles.clickable} ${styles.invoiceStack}`} verticalAlign='center'>
                                            <FontIcon aria-label="Kopieer" iconName="copy" className={styles.copyInvoiceIcon} />
                                            <Label className={`${styles.invoiceLabel} ${styles.onchainLabel}`}>BTC {invoice?.sats / 100000000}</Label>
                                        </Stack>
                                    </div>
                                    <Stack horizontalAlign='center'>
                                        <ProgressIndicator className={styles.invoiceProgressIndicator} />
                                        <br />
                                        <Stack horizontalAlign='start'>
                                            <Label><b>Let op:</b></Label>
                                            <li>Betaal uw bestelling in 1 transactie.</li>
                                            <li>Uw transactie is valide na 6 bevestigingen.</li>
                                            <li>Indien uw betaling na 48 uur niet door ons is ontvangen word uw bestelling verwijderd.</li>
                                        </Stack>
                                        <br />
                                        <Label>Zodra uw betaling door ons is ontvangen ontvangt u een bevestiging van uw bestelling.</Label>
                                        <br />
                                        <PrimaryButton text="Sluiten" onClick={() => { ClosePayment(); }} />
                                    </Stack>
                                </div> :
                                paymentSuccess ?
                                    <div style={{ height: "100%", width: "100%" }}>
                                        <Stack horizontalAlign='center'>
                                            <img className={styles.invoiceImage} onClick={() => { ClosePayment(); }} src={`${process.env.PUBLIC_URL}/assets/success.gif`} alt="" />
                                            <h2>Betaling ontvangen</h2>
                                            <Label className={styles.betalingOntvangenLabel}>We sturen een bevestiging van je bestelling naar je mailbox.</Label>
                                            <PrimaryButton text="Sluiten" onClick={() => { ClosePayment(); }} />
                                            <br />
                                        </Stack>
                                        <MessageBar messageBarType={MessageBarType.severeWarning}>We horen van sommige klanten dat onze emails naar de spam folder worden gezet.</MessageBar>
                                    </div>
                                    : <div>
                                        <img className={styles.invoiceImage} onClick={() => { ClosePayment(); }} src={`data:image/jpeg;base64,${invoice?.qrCode}`} alt="" />
                                        <Label>Scan de QR Code of kopieer de invoice naar je betaal wallet.</Label>
                                        <div className={`${styles.aPanel} ${styles.clickable}`} onClick={() => { copyToClipboard(invoice?.invoice); }}>
                                            <Stack horizontal className={`${styles.invoiceStack} ${styles.clickable}`} verticalAlign='center'>
                                                <FontIcon aria-label="Kopieer" iconName="copy" className={styles.copyInvoiceIcon} />
                                                <Label className={styles.invoiceLabel}>{invoice?.invoice}</Label>
                                            </Stack>
                                        </div>
                                        {invoiceTimoutPercentage > 0.04 ?
                                            <ProgressIndicator className={styles.invoiceProgressIndicator} percentComplete={invoiceTimoutPercentage} /> :
                                            <ProgressIndicator className={styles.invoiceProgressIndicator} />}
                                        <Stack horizontal horizontalAlign='center'>
                                            <PrimaryButton text="Via onchain transactie betalen" onClick={onOnChainPayment} />
                                        </Stack>
                                    </div>}
                        </Stack>
                    </Dialog>
                    {/* iDeal popup */}
                    <Dialog
                        hidden={!waitingIdealPayment}
                        dialogContentProps={{ type: DialogType.normal }}
                        onDismiss={() => { ClosePayment(); }}
                        modalProps={paymentSuccess ? { styles: { main: { maxHeight: "100%!important", maxWidth: "100%!important", backgroundColor: "transparent", boxShadow: "none", overflowY: "auto" } } }
                            : { styles: { main: { maxHeight: "100%!important", maxWidth: "100%!important", backgroundColor: "white", boxShadow: "none", overflowY: "auto" } } }}
                    >
                        {paymentSuccess ?
                            <div style={{ height: "100%", width: "100%" }}>
                                <Stack horizontalAlign='center' style={{ borderRadius: 10, backgroundColor: "white" }}>
                                    <img className={styles.invoiceImage} onClick={() => { ClosePayment(); }} src={`${process.env.PUBLIC_URL}/assets/success.gif`} alt="" />
                                    <h2>Betaling ontvangen</h2>
                                    <Label className={styles.betalingOntvangenLabel}>We sturen een bevestiging van je bestelling naar je mailbox.</Label>
                                    <MessageBar messageBarType={MessageBarType.severeWarning}>We horen van sommige klanten dat onze emails naar de spam folder worden gezet.</MessageBar><br />
                                    <PrimaryButton text="Sluiten" onClick={() => { ClosePayment(); }} />
                                    <br />
                                </Stack>
                            </div>
                            :
                            <Stack horizontalAlign='center'>
                                <h2>We wachten op uw betaling</h2>
                                <ProgressIndicator className={styles.invoiceProgressIndicator} />
                                <label>Zodra we de betaling hebben ontvangen ontvangt u van ons een email met uw bestelling.</label>
                            </Stack>}
                    </Dialog>
                    {selectedAlertCard && <EmailAlertComponent card={selectedAlertCard} userEmail={userEmail} callBack={SetAlertCallback} />}
                    <Stack horizontalAlign='center'>
                        {showLocaleBanner && <NonNLbannerComponent discard={() => { setshowLocaleBanner(false); }} />}
                        {showBanner && <BannerComponent content=<div>
                            <span dangerouslySetInnerHTML={{ __html: SITE_MESSAGE.replace("[LINKTOALERTHOWTO]", "") }} />
                            <Stack horizontal horizontalAlign='center'>
                                {SITE_MESSAGE.indexOf("[LINKTOALERTHOWTO]") !== -1 &&
                                    <DefaultButton text={Strings.ShowHow} style={{ marginTop: 15 }} onClick={ShowAlertCoachmarks} />}
                                <PrimaryButton text={Strings.Hide} style={{ marginTop: 15, marginLeft: 5 }} onClick={() => {
                                    setshowBanner(false);
                                    setalertCoachmarkVisible(false);
                                }} />
                            </Stack>
                        </div> />}

                        <HeaderFC />

                        {ReviewID ? <Review id={ReviewID} isDev={DevEnabled} />
                            : showCheckOut || invoice ? <CheckoutComponent onCheckOutIDeal={onCheckOutIDeal} usdprice={usdprice} eurprice={eurprice} debug={DebugEnabled} ShowMessage={ShowMessage} onCancel={() => { setshowCheckOut(false); }} onCheckOut={onCheckOut} satprice={satprice} shoppingcart={shoppingkart} />
                                :
                                <div className={styles.mainSection} >
                                    {PROMO1_IMAGE_URL && <NavLink to='/Promo'>
                                        <Image className={`${styles.promoLogo} ${AnimationsEnabled && styles.pulse5} ${styles.promoRight}`} src={`${process.env.PUBLIC_URL}${PROMO1_IMAGE_URL}`} alt="" imageFit={ImageFit.cover} />
                                        </NavLink>
                                    }
                                    {PROMO2_IMAGE_URL && <NavLink to='/Promo2'>
                                        <Stack horizontalAlign='end'>
                                            <Image className={`${styles.promoLogo} ${AnimationsEnabled && styles.pulse5}`} src={`${process.env.PUBLIC_URL}${PROMO2_IMAGE_URL}`} alt="" imageFit={ImageFit.cover} />
                                        </Stack>
                                    </NavLink>}
                                    {/* Header menu  */}    <Stack className={styles.headerMainMenu} style={{ overflowY: 'visible' }} horizontalAlign='start'>
                                        <Stack horizontal horizontalAlign="start" style={{ width: "100%" }}  >
                                            <Stack horizontal style={{ width: "100%" }} horizontalAlign='center'>
                                                <Stack verticalAlign='center' style={{ paddingLeft: 5 }}>
                                                    <FiltersComponent content={<Stack>
                                                        <Stack verticalAlign='center' horizontal onClick={() => { setsearchAll(!searchAll); }}>
                                                            <Toggle style={{ marginRight: 5, marginBottom: 0 }} checked={searchAll} inlineLabel />
                                                            <Label style={{ fontSize: windowSize.x > 400 ? "small" : "x-small", float: "right", color: "gray", cursor: "pointer", marginTop: -10 }}>{Strings.SearchInAllSets}</Label>
                                                        </Stack>
                                                        <Stack horizontal verticalAlign='center' onClick={() => { setkeepFilterMenuOpen(true); toggleAvailable(); }}>
                                                            <Toggle style={{ marginRight: 5, marginBottom: -7 }} checked={!showAvailableOnly} inlineLabel />
                                                            <Label style={{ fontSize: windowSize.x > 400 ? "small" : "x-small", float: "right", color: "gray", cursor: "pointer", marginTop: -3 }} >{Strings.SoldoutToggle}</Label>
                                                        </Stack>
                                                        <ChoiceGroup className={styles.filterChoice} defaultSelectedKey="B"
                                                            selectedKey={currentFilter}
                                                            options={filterOptions}
                                                            //  label="Filters"
                                                            onChange={(ev, option) => { filter(option ? option.key : Filters.PriceUp, cards); }} />
                                                    </Stack>}
                                                        preDisable={() => {
                                                            let val = keepFilterMenuOpen;
                                                            setkeepFilterMenuOpen(false);
                                                            return val;
                                                        }} />
                                                    <span style={{ fontSize: "xx-small", padding: "0px", paddingLeft: "2px", margin: "0px" }}>Filter</span>
                                                </Stack>
                                                <div className={`${styles.mainMenuItems} ${styles.searchBox}`}>
                                                    <Stack horizontal tokens={cardTokens}>
                                                        <TextField type="Search"
                                                            iconProps={{
                                                                iconName: 'search',
                                                                onClick: () => { onSearchBoxChange(searchText) }
                                                            }}
                                                            disabled={searchBusy || (showOnly != ProductType.All && showOnly != ProductType.Cards)}
                                                            className={styles.searchBox}
                                                            value={searchText}
                                                            placeholder={searchAll ? Strings.SearchInAllSets : Strings.SearchInSet}
                                                            onChange={(e, newvalue) => onSearchBoxChange(newvalue)} />
                                                    </Stack>
                                                </div>
                                                <Stack horizontalAlign='end' tokens={cardTokens}>
                                                    <Image className={styles.menuIcon} src={`${process.env.PUBLIC_URL}/assets/Hamburger_icon.svg.webp?v=${GlobalImagesVersion}`} alt="Menu" onClick={() => { setshowSettings(true); }} />
                                                    <span style={{ fontSize: "xx-small", padding: "0px", paddingRight: "8px", margin: "0px", marginTop: "-5px" }}>Menu</span>
                                                </Stack>
                                            </Stack>
                                        </Stack>
                                        <Stack style={{ whiteSpace: "nowrap", width: "100%" }} wrap verticalAlign='center' horizontalAlign='start' horizontal className={styles.mainButtonSection} >

                                        </Stack>
                                    </Stack>
                                    {firstLoad ? 
                                    <WelcomeComponent ShowAlertCoachmarks={ShowAlertCoachmarks}
                                        //GetStateVarExtern={GetStateVarExtern}
                                        UpdateStateExtern={UpdateStateExtern}
                                        onSetSelectedSet={onSetSelectedSet}
                                        DoSearch={onSearchBoxChange}
                                        Sets={sets} />
                                        : props.showText ? <div style={{ paddingLeft: 10, color: "rgb(100,100,100)" }}>
                                            <div dangerouslySetInnerHTML={{ __html: Strings[props.showText] }} />
                                        </div> : 
                                        <div>
                                            {/* {(showOnly ===  ProductType.Cards || showOnly === ProductType.All) && <SetInfoComponent toggleAvailable={toggleAvailable} sets={sets} selectedSetID={localselectedSetKey}/>} */}
                                            <div className={`${styles.divTable}`}>
                                                <div className={styles.divTableRow}>
                                                    <div className={`${styles.divTableCell} ${styles.cardsSection}`}>
                                                        {showOnly === ProductType.Single ?
                                                            <ProductViewerComponent SetSelectedProductForAlert={SetSelectedProductForAlert}
                                                                                    SetSelectedSet={onSetSelectedSet}
                                                                                    allProducts={boosters.concat(collections.concat(misc))}
                                                                                    onBuyClick={onBuyClick}
                                                                                    EurPrice={eurprice}
                                                                                    SatPrice={satprice}
                                                                                    cards={cards}
                                                                                    onImageClick={ShowImagePopup} 
                                                                                    AlertCoachmarkVisible={false} 
                                                                                    ShowToast={undefined} />
                                                            : showOnly === ProductType.Booster ?
                                                                <Boosters SetSelectedProductForAlert={SetSelectedProductForAlert} AlertCoachmarkVisible={alertCoachmarkVisible} products={boosters} onBuyClick={onBuyClick} isdev={DevEnabled} eurprice={eurprice} satprice={satprice} onImageClick={ShowImagePopup} windowSize={windowSize} />
                                                                : showOnly === ProductType.Collection ?
                                                                    <Collections SetSelectedProductForAlert={SetSelectedProductForAlert} AlertCoachmarkVisible={alertCoachmarkVisible} products={collections} onBuyClick={onBuyClick} isdev={DevEnabled} eurprice={eurprice} satprice={satprice} onImageClick={ShowImagePopup} windowSize={windowSize} />
                                                                    : showOnly === ProductType.Misc ?
                                                                        <Misc SetSelectedProductForAlert={SetSelectedProductForAlert} AlertCoachmarkVisible={alertCoachmarkVisible} products={misc} onBuyClick={onBuyClick} isdev={DevEnabled} eurprice={eurprice} satprice={satprice} onImageClick={ShowImagePopup} windowSize={windowSize} />
                                                                        : showOnly === ProductType.Promo ?
                                                                            <PromoComponent windowWidth={windowSize.x} eurprice={eurprice} satprice={satprice} />
                                                                            : showOnly === ProductType.Promo2 ?
                                                                                <Promo2Component windowWidth={windowSize.x} eurprice={eurprice} satprice={satprice} />
                                                                                : <div></div>}
                                                        {showOnly == ProductType.All || showOnly == ProductType.Cards ? pageCardSet.length ?
                                                            <Stack className={styles.mainSection}>
                                                                <Stack horizontal style={{ width: "100%", cursor: "pointer" }} >
                                                                    <Stack horizontal >
                                                                        {/* <Stack>
                                                                                    <Label className={styles.boosterLabel} >{Strings.Cards}</Label>
                                                                                </Stack> */}
                                                                    </Stack>
                                                                </Stack>
                                                                {/* <hr className={styles.mainhr} /> */}
                                                                {showcards && 
                                                                    <Stack horizontal wrap tokens={cardTokens} horizontalAlign='start' style={{ maxWidth: "" }}>
                                                                    {pageCardSet.map(card => {
                                                                        return <PokemonCardFC hideSwipe={windowSize.x < 800 ? false : true}
                                                                            AlertCoachmarkVisible={alertCoachmarkVisible}
                                                                            eurprice={eurprice}
                                                                            shoppingkart={shoppingkart}
                                                                            animationsEnabled={AnimationsEnabled && IsNull(popupUrl)}
                                                                            card={card}
                                                                            onBuyClick={onBuyClick}
                                                                            SetSelectedProductForAlert={SetSelectedProductForAlert} />
                                                                    })}
                                                                </Stack>}
                                                                <br />
                                                                <Stack horizontal horizontalAlign='center' tokens={cardTokens}>
                                                                    <PrimaryButton onClick={() => { numberOfPages > pageIndex && loadMore(); }} className={`${styles.loadMoreButton} ${numberOfPages <= pageIndex ? styles.disabledButton : styles.pulse}`} text={Strings.LoadMoreCards} />
                                                                    <DefaultButton onClick={() => { window.scroll(0, 0); }}>{Strings.ScrollToTop}</DefaultButton>
                                                                </Stack>
                                                            </Stack>
                                                            : <Stack horizontalAlign='center'>
                                                                {loading === false && <>
                                                                                        <Image src={process.env.PUBLIC_URL + `/assets/NothingFound.webp?v=${GlobalImagesVersion}`} alt="" imageFit={ImageFit.contain} style={{ height: 300 }} />
                                                                                        <Label className={styles.nothingFoundLabel}>{Strings.NoCardsAvailable}</Label>
                                                                                        <Toggle label={Strings.SoldoutToggle} checked={!showAvailableOnly} inlineLabel onChange={toggleAvailable} />
                                                                                      </>}
                                                            </Stack> : <div></div>}
                                                        {(showOnly === ProductType.Cards || showOnly === ProductType.All) && producten.length > 0 && <Producten products={producten} onBuyClick={onBuyClick} isdev={DevEnabled} eurprice={eurprice} satprice={satprice} onImageClick={ShowImagePopup} windowSize={windowSize} AlertCoachmarkVisible={alertCoachmarkVisible} SetSelectedProductForAlert={SetSelectedProductForAlert} />}
                                                    </div>
                                                    <div className={`${styles.divTableCell}`}>
                                                        <div className={`${styles.shoppingcart}`}>
                                                            <Stack style={{ width: "100%" }} horizontalAlign='end' >
                                                                <Shoppingcart eurprice={eurprice}
                                                                    showPopup={(v: string) => { setpopupUrl(v); }}
                                                                    pShowMessage={ShowMessage}
                                                                    satprice={satprice}
                                                                    usdprice={usdprice}
                                                                    shoppingcart={shoppingkart}
                                                                    onCheckOut={onPreCheckOut}
                                                                    onSmallCartClick={onSmallCartClick} />
                                                            </Stack>
                                                        </div>
                                                        <div>
                                                            {(showOnly == ProductType.All || showOnly == ProductType.Cards) &&
                                                                <SetsMenuComponent sets={sets} onSetSelectedSet={onSetSelectedSet} selectedSetKey={localselectedSetKey} />}
                                                            <div className={`${styles.setLogoContainer}`}>
                                                                <Stack style={{ width: "100%" }} horizontalAlign='center' horizontal>
                                                                    <IconButton iconProps={{ iconName: 'AddNotes' }} styles={{
                                                                        icon: { color: 'blue', fontSize: windowSize.x > 960 ? 28 : 14 },
                                                                        root: {
                                                                            margin: 0,
                                                                            padding: 0,
                                                                            selectors: {
                                                                                '& .ms-Button-icon:hover, .ms-Button-flexContainer:hover': {
                                                                                    backgroundColor: 'lightblue',
                                                                                    color: 'darkblue'
                                                                                },
                                                                            }
                                                                        },
                                                                    }} title="Meer" src={`${process.env.PUBLIC_URL}/assets/Hamburger_icon.svg.webp?v=${GlobalImagesVersion}`} text={sets.find(set => set.id == localselectedSetKey)?.name} menuProps={{ items: allMenu, shouldFocusOnMount: true, subMenuHoverDelay: 250 }} />
                                                                </Stack>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>}
                                    {windowSize.x < 400 && showOnly === ProductType.All && !firstLoad &&
                                        showReviews &&
                                        <div style={{ maxWidth: windowSize.x - 25, overflow: "hidden" }}>
                                            <CarouselComponent animationsEnabled={AnimationsEnabled} isDev={DevEnabled} />
                                        </div>
                                    }
                                    {/* Footer */}
                                    {!firstLoad && <Footer />}
                                </div>}
                    </Stack>
                </div>
            </ImageViewerSplashContextProvider>
    );
}

export default MainComponent;